/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(value) {
    if (!('AllowedTransferFromMyGames' in value) || value['AllowedTransferFromMyGames'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AllowedTransferFromMyGames': json['AllowedTransferFromMyGames'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AllowedTransferFromMyGames': value['AllowedTransferFromMyGames'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions.js.map